import { React, FelaComponent, childrenPropType } from '../../dependencies';

import * as styles from './Header.styles';

function Header({ children }) {
    return <FelaComponent style={styles.header}>{children}</FelaComponent>;
}

Header.propTypes = {
    children: childrenPropType.isRequired,
};

export default Header;
